module.exports = __webpack_public_path__ + "img/angebot-erhalten.ecbad049.svg";